<template>
    <div>
        <notification-modal :firstAction="firstAction" :firstActionText="firstActionText" :messageTitle="messageTitle" :message="message" :notificationType="notificationType" :resetVariable="resetVariable"></notification-modal>
    </div>
</template>

<script>
export default {
    data () {
        return {
            messageTitle: 'Upload completed',
            message: 'Your profile image has been updated.',
            notificationType: 'success',
            firstAction: 'close',
            firstActionText: '&nbsp;&nbsp;&nbsp;OK&nbsp;&nbsp;&nbsp;',
            resetVariable: 'showUploadMessage'
        }
    },
}
</script>